import styled from 'styled-components'

const Box = styled.div`
  padding: 27px 42px 35px 40px;
  gap: 24px 0px;
`

export const s = { Box }
